import { Box, Text, Textarea } from '@mantine/core';
import classes from '../../../core/style/PrintStyles.module.css';

interface CustomTextAreaProps {
  label: string;
  inputProps: any;
  required?: boolean;
  disabled?: boolean;
  minRows?: number;
  isPrint?: boolean;
}

export function CustomTextArea({
  label,
  inputProps,
  required,
  disabled,
  minRows
}: CustomTextAreaProps) {
  const value = inputProps.value ?? '';

  return (
    <Box mt={10}>
      <Textarea
        {...inputProps}
        // stejně jako CustomTextInput: value nikdy null (Mantine controlled input varuje)
        value={value}
        withAsterisk={required}
        disabled={disabled}
        autosize
        label={label}
        minRows={minRows ?? 4}
        mt={10}
        radius={10}
        className="print-hide"
      />
      <Box className="screen-hide">
        <Text size="sm">{label}</Text>
        <div className="print-textarea-box">{value || ' '}</div>
      </Box>
    </Box>
  );
}
